/* Waïloa – filtres, tri, chargement progressif des collections.
   Version robuste : aucun état « chargement » ne peut rester bloqué
   (délai max, repli sur un vrai lien, fonctions du thème appelées seulement si elles existent). */
var showLessText = (document.documentElement.lang || 'fr').indexOf('fr') === 0 ? 'Voir moins' : 'Show less';
var showMoreText = (document.documentElement.lang || 'fr').indexOf('fr') === 0 ? 'Voir plus' : 'Show more';
var clearAllFilterButton = false,
  minPriceRange = '',
  maxPriceRang = '';
var wlFiltersReady = false;
var triggered = false;

function wlCall(name, arg) {
  try {
    if (typeof window[name] === 'function') window[name](arg);
  } catch (e) {
    if (window.console) console.warn('[Waïloa] ' + name, e);
  }
}
function wlAfterRender(root) {
  if (!root) return;
  if (typeof window.initQuickViewAction === 'function') {
    root.querySelectorAll('.quickView-action-link').forEach(function (el) {
      try { window.initQuickViewAction(el); } catch (e) {}
    });
  }
  wlCall('colorSwatchChanged', root);
  wlCall('productGridImageSlider', root);
  /* Les cartes ajoutées ne doivent jamais rester invisibles (animations AOS) */
  root.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
  try {
    if (typeof animationStatus !== 'undefined' && animationStatus && window.AOS) window.AOS.refreshHard();
  } catch (e) {}
  document.dispatchEvent(new CustomEvent('wl:products-rendered', { detail: { root: root } }));
}
function wlSectionUrl(url, sectionId) {
  if (!sectionId) return url;
  var u = new URL(url, window.location.origin);
  u.searchParams.set('section_id', sectionId);
  return u.pathname + u.search;
}
function fetchFilterData(url) {
  var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
  return fetch(url, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
    .then(function (response) {
      clearTimeout(timer);
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .catch(function (err) {
      clearTimeout(timer);
      throw err;
    });
}

function wlInitFilters() {
  if (wlFiltersReady) return;
  wlFiltersReady = true;
  applyFilters();
  sortByOptions();
  sortByClose();
  showMoreFilters();
  wlDecorateFilters();
  var clearAllfilter = document.getElementById('removeFilterdata');
  if (clearAllfilter) {
    clearAllfilter.addEventListener('click', function (e) {
      e.preventDefault();
      var section = document.getElementById('CollectionProductsContainer');
      if (section) getFilterData(clearAllfilter, section.dataset.id, clearAllfilter.getAttribute('href'));
    });
  }
  wlWatchInfinite();
  loadMoreCollection();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wlInitFilters);
} else {
  wlInitFilters();
}
window.addEventListener('load', wlInitFilters);

/* ---------- Mise en avant des filtres clés (taille, couleur, disponibilité, type) ---------- */
function wlDecorateFilters() {
  var form = document.getElementById('FiltersForm');
  if (!form) return;
  var groups = [
    ['size', /(taille|size|pointure|gr[öo]ße|talla|サイズ)/i, 1],
    ['color', /(couleur|colou?r|farbe|カラー|色)/i, 2],
    ['avail', /(disponib|availab|verfügbar|disponibilidad|在庫)/i, 3],
    ['type', /(type|typ|tipo|タイプ|種類|catégorie|category)/i, 4],
    ['price', /(prix|price|preis|precio|価格)/i, 5]
  ];
  var count = 0;
  form.querySelectorAll('.filterby__list-item').forEach(function (d) {
    var s = d.querySelector('summary');
    if (!s || d.dataset.wlf) return;
    var label = s.textContent.trim();
    for (var i = 0; i < groups.length; i++) {
      if (groups[i][1].test(label)) {
        d.dataset.wlf = groups[i][0];
        d.classList.add('wl-f', 'wl-f--' + groups[i][0]);
        d.style.order = groups[i][2];
        if (groups[i][0] !== 'price' && count < 3 && window.innerWidth > 0) { d.setAttribute('open', ''); count++; }
        break;
      }
    }
    if (!d.dataset.wlf) { d.dataset.wlf = 'other'; d.style.order = 10; }
  });
}

function showMoreFilters() {
  var filterForm = document.getElementById('FiltersForm');
  if (!filterForm) return;
  filterForm.querySelectorAll('.filters-expand').forEach(function (showMoreFilter) {
    if (showMoreFilter.dataset.wlBound) return;
    showMoreFilter.dataset.wlBound = '1';
    showMoreFilter.addEventListener('click', function (e) {
      e.preventDefault();
      var more = showMoreFilter.parentNode.querySelector('.more-options');
      var active = showMoreFilter.classList.toggle('active');
      if (more) more.style.display = active ? 'block' : 'none';
      var sp = showMoreFilter.querySelector('span');
      if (sp) sp.textContent = active ? showLessText : showMoreText;
    });
  });
}

function applyFilters() {
  var section = document.getElementById('CollectionProductsContainer');
  if (!section) return;
  var sectionParent = section.closest('.shopify-section') || document;
  var sectionId = section.dataset.id;
  var filterForm = document.getElementById('FiltersForm');
  if (!filterForm) return false;
  var rangeInput = document.querySelectorAll('.mg-range-input input'),
    priceInput = document.querySelectorAll('.mg-price-input input'),
    range = document.querySelector('#priceSilderProgress');
  if (rangeInput.length > 1 && priceInput.length > 1) {
    var priceGap = parseInt(rangeInput[0].getAttribute('step'), 10) || 1;
    var rangeSlider = function (input, event) {
      var minVal = parseInt(rangeInput[0].value, 10),
        maxVal = parseInt(rangeInput[1].value, 10);
      minPriceRange = (minVal / rangeInput[0].max) * 100 + '%';
      maxPriceRang = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
      if (maxVal - minVal < priceGap) {
        if (event.target.className === 'priceslider-range-min') rangeInput[0].value = maxVal - priceGap;
        else rangeInput[1].value = minVal + priceGap;
      } else {
        priceInput[0].value = minVal;
        priceInput[1].value = maxVal;
        if (range) { range.style.left = minPriceRange; range.style.right = maxPriceRang; }
      }
    };
    priceInput.forEach(function (input) {
      if (input.dataset.wlBound) return;
      input.dataset.wlBound = '1';
      input.addEventListener('change', function () {
        var minPrice = parseInt(priceInput[0].value, 10),
          maxPriceRange = parseInt(priceInput[1].getAttribute('data-max-value'), 10);
        if (minPrice > maxPriceRange) priceInput[0].value = maxPriceRange;
        if (window.innerWidth > 767) getFilterData(input, sectionId);
      });
    });
    rangeInput.forEach(function (input) {
      if (input.dataset.wlBound) return;
      input.dataset.wlBound = '1';
      input.addEventListener('change', function (event) {
        rangeSlider(input, event);
        if (window.innerWidth > 767) getFilterData(input, sectionId);
      });
      input.addEventListener('input', function (event) { rangeSlider(input, event); });
    });
  }
  if (!filterForm.dataset.wlBound) {
    filterForm.dataset.wlBound = '1';
    filterForm.addEventListener('change', function (e) {
      var t = e.target;
      if (window.innerWidth > 767 && t && t.type === 'checkbox') getFilterData(t, sectionId);
    });
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      getFilterData(filterForm, sectionId);
      document.body.classList.remove('open-filter-sort');
    });
  }
  sectionParent.querySelectorAll('a.mg-applied-filter-remove').forEach(function (removeFilter) {
    if (removeFilter.dataset.wlBound) return;
    removeFilter.dataset.wlBound = '1';
    removeFilter.addEventListener('click', function (e) {
      e.preventDefault();
      getFilterData(removeFilter, sectionId, removeFilter.getAttribute('href'));
    });
  });
}

function sortByClose() {
  document.querySelectorAll('.filter-close-mobile').forEach(function (closeBtn) {
    if (closeBtn.dataset.wlBound) return;
    closeBtn.dataset.wlBound = '1';
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sortMenu = closeBtn.closest('details');
      if (sortMenu) sortMenu.removeAttribute('open');
    });
  });
}
function sortByOptions() {
  var section = document.getElementById('CollectionProductsContainer');
  if (!section) return;
  var sectionId = section.dataset.id;
  var sortBy = document.querySelectorAll('[name="sort_by"]');
  sortBy.forEach(function (sort) {
    if (sort.dataset.wlBound) return;
    sort.dataset.wlBound = '1';
    sort.addEventListener('change', function (e) {
      e.preventDefault();
      sortBy.forEach(function (s) { s.parentNode.classList.remove('selected'); });
      sort.parentNode.classList.add('selected');
      var sortMenu = sort.closest('details');
      if (sortMenu) sortMenu.removeAttribute('open');
      getFilterData(sort, sectionId);
    });
  });
}
function checkUrlParam() {
  var matchString = '#filters-sidebar';
  if (window.location.toString().indexOf(matchString) > -1 && window.innerWidth > 767) return matchString;
  return '';
}

function wlSetBusy(on) {
  var c = document.getElementById('CollectionProductsContainer');
  if (!c) return;
  c.classList.toggle('wl-busy', !!on);
  c.setAttribute('aria-busy', on ? 'true' : 'false');
}

function getFilterData(input, sectionId, remove) {
  var filterForm = document.getElementById('FiltersForm');
  var searchParameters = filterForm ? new URLSearchParams(new FormData(filterForm)).toString() : '';
  var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
  var _updateUrl = window.location.pathname + '?' + searchParameters;
  if (remove) {
    _updateUrl = remove;
    url = wlSectionUrl(remove, sectionId);
  }
  wlSetBusy(true);
  return fetchFilterData(url)
    .then(function (responseText) {
      var resultData = new DOMParser().parseFromString(responseText, 'text/html');
      var itemResultCount = resultData.querySelector('.products-count');
      var sortEl = resultData.getElementById('toolbox-sort');
      var sortByHtml = sortEl ? sortEl.innerHTML : '';
      var html = resultData.getElementById('CollectionProductsContainer');
      var elmnt = document.getElementById('CollectionProductsContainer');
      if (html && elmnt) {
        elmnt.innerHTML = html.innerHTML;
        wlAfterRender(elmnt);
      } else if (elmnt) {
        var productResultContainer = elmnt.querySelector('[data-collection-products]');
        if (productResultContainer && typeof noResultFound !== 'undefined') productResultContainer.innerHTML = noResultFound;
      }

      /* Page recherche */
      var totalresultcount = resultData.querySelector('.searchbar__result-heading');
      var totalEl = document.querySelector('.searchbar__result-heading');
      if (totalresultcount && totalEl) totalEl.innerHTML = totalresultcount.innerHTML;
      var postResulthtml = resultData.getElementById('data-articale-result');
      var postResultElement = document.getElementById('data-articale-result');
      var searchResultElement = resultData.querySelector('[data-serach-pagination]');
      var searchElement = document.querySelector('[data-serach-pagination]');
      if (searchElement) searchElement.innerHTML = searchResultElement && searchResultElement.querySelector('.pagination') ? searchResultElement.innerHTML : '';
      if (postResultElement) {
        postResultElement.innerHTML = postResulthtml ? postResulthtml.innerHTML : '';
        postResultElement.classList.toggle('searchbar__result-content', !!postResulthtml);
      }
      var pageResulthtml = resultData.getElementById('data-page-result');
      var pageResultElement = document.getElementById('data-page-result');
      if (pageResultElement) {
        pageResultElement.innerHTML = pageResulthtml ? pageResulthtml.innerHTML : '';
        pageResultElement.classList.toggle('searchbar__result-content', !!pageResulthtml);
      }

      /* Mise à jour du panneau de filtres (valeurs et compteurs) */
      var currentFilterItems = document.querySelectorAll('.filterby__list-item');
      resultData.querySelectorAll('.filterby__list-item').forEach(function (filterItem, index) {
        var matchItem = currentFilterItems[index];
        if (!matchItem) return;
        try {
          if (matchItem.querySelector('.priceslider-range-min')) {
            ['.mg-range-input', '.mg-price-input', '.mg-slider'].forEach(function (sel) {
              var a = matchItem.querySelector(sel), b = filterItem.querySelector(sel);
              if (a && b) a.innerHTML = b.innerHTML;
            });
          } else {
            var a = matchItem.querySelector('.filter-name-list'), b = filterItem.querySelector('.filter-name-list');
            if (a && b) a.innerHTML = b.innerHTML;
          }
        } catch (e) {}
      });
      var inputId = input && input.getAttribute ? input.getAttribute('id') : null;
      var updateInput = inputId ? document.getElementById(inputId) : null;
      if (updateInput && window.innerWidth > 767) {
        try { updateInput.focus({ preventScroll: true }); } catch (e) {}
        var moreOption = updateInput.closest('.more-options');
        if (moreOption) moreOption.style.display = 'block';
      }
      if (window.innerWidth <= 767) {
        var filterSideDrawer = document.getElementById('filters-sidebar');
        var closeBtn = filterSideDrawer && filterSideDrawer.querySelector('[data-side-drawer-close]');
        if (closeBtn) closeBtn.click();
      }
      var countEl = document.querySelector('.products-count');
      if (itemResultCount && countEl) countEl.innerHTML = itemResultCount.innerHTML;
      var sortBox = document.getElementById('toolbox-sort');
      if (sortBox && sortByHtml) sortBox.innerHTML = sortByHtml;
      /* Compteur de filtres actifs dans la barre mobile */
      var badgeNew = resultData.querySelector('[data-wl-filter-count]');
      document.querySelectorAll('[data-wl-filter-count]').forEach(function (b) {
        b.textContent = badgeNew ? badgeNew.textContent : '';
        b.hidden = !badgeNew || !badgeNew.textContent.trim();
      });
      try { history.pushState({}, '', _updateUrl); } catch (e) {}
    })
    .catch(function () {
      /* Réseau lent ou erreur : on recharge simplement la page filtrée */
      window.location.href = _updateUrl;
    })
    .finally(function () {
      wlSetBusy(false);
      triggered = false;
      sortByOptions();
      applyFilters();
      showMoreFilters();
      wlDecorateFilters();
      wlCall('sideDrawerEventsInit');
      sortByClose();
      wlWatchInfinite();
      loadMoreCollection();
    });
}

/* ---------- Chargement progressif (défilement ou bouton) ---------- */
var wlObserver = null;
function wlWatchInfinite() {
  var el = document.querySelector('[data-scroll]');
  if (!el) return;
  if ('IntersectionObserver' in window) {
    if (wlObserver) wlObserver.disconnect();
    wlObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) infineScroll(en.target); });
    }, { rootMargin: '600px 0px' });
    wlObserver.observe(el);
  } else {
    window.addEventListener('scroll', function () {
      var s = document.querySelector('[data-scroll]');
      if (s && s.getBoundingClientRect().top < window.innerHeight + 600) infineScroll(s);
    }, { passive: true });
  }
}

function infineScroll(scrollElement) {
  if (!scrollElement || triggered) return;
  var link = scrollElement.querySelector('a[href]');
  if (!link) return;
  var nextUrl = link.getAttribute('href');
  var container = document.getElementById('CollectionProductsContainer');
  var sectionId = container ? container.dataset.id : null;
  var loader = scrollElement.querySelector('.load');
  triggered = true;
  link.hidden = true;
  if (loader) loader.classList.remove('hidden');
  fetchFilterData(wlSectionUrl(nextUrl, sectionId))
    .then(function (responseText) {
      var resultData = new DOMParser().parseFromString(responseText, 'text/html');
      var html = resultData.getElementById('CollectionProductsContainer');
      var grid = container && container.querySelector('[data-collection-products]');
      var incoming = html && html.querySelector('[data-collection-products]');
      if (!grid || !incoming) throw new Error('no-grid');
      var frag = document.createDocumentFragment();
      var wrap = document.createElement('div');
      Array.prototype.slice.call(incoming.children).forEach(function (child) {
        wrap.appendChild(child);
      });
      while (wrap.firstChild) frag.appendChild(wrap.firstChild);
      scrollElement.remove();
      grid.appendChild(frag);
      wlAfterRender(grid);
      wlCall('collectionCarousel');
      triggered = false;
      wlWatchInfinite();
      loadMoreCollection();
    })
    .catch(function () {
      /* Jamais de chargement infini : on rend la main avec un vrai lien vers la page suivante */
      triggered = false;
      if (loader) loader.classList.add('hidden');
      scrollElement.removeAttribute('data-scroll');
      scrollElement.classList.add('wl-infinite-fallback');
      link.hidden = false;
      link.classList.add('wl-btn', 'wl-btn--line');
      if (!link.textContent.trim()) link.textContent = link.getAttribute('aria-label') || showMoreText;
    });
}

function loadMoreCollection() {
  var loadmoreButton = document.querySelector('.collection-load-more');
  if (!loadmoreButton || loadmoreButton.dataset.wlBound) return;
  loadmoreButton.dataset.wlBound = '1';
  loadmoreButton.addEventListener('click', function (event) {
    event.preventDefault();
    var scrollElement = document.querySelector('[data-load-more]');
    if (scrollElement) infineScroll(scrollElement);
  });
}
